export default __webpack_public_path__ + "static/media/gallery_16.9373ca36.jpg";